import { useQuery } from "@tanstack/react-query";

import { axiosInstance } from "@needl-ai/common/lib/axios";

import type { AskNeedlTools } from "@/types/api";

export const TOOLS_QUERY_KEY = "askneedl-tools";
const API_ROUTES = {
  askNeedlTools: () => `/chat/tools`,
};

export const useFetchAskNeedlTools = () => {
  return useQuery({
    queryKey: [TOOLS_QUERY_KEY],
    queryFn: async () => {
      const response = await axiosInstance.get<ResponseType>(
        API_ROUTES.askNeedlTools()
      );
      return response;
    },
    select: (data) => {
      const tools = data?.data?.tools;
      return tools;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes - tools don't change frequently
  });
};

type ResponseType = {
  tools: AskNeedlTools;
};
